window.addEventListener("DOMContentLoaded", function() { 

    let productSection = document.querySelectorAll('.productSection')  

    productSection.forEach(section => {
        if(!section.classList.contains('noProduct')) {
            setUpProduct(section)
        }
    })

    if(Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
            if (e.target.dataset.shopifyEditorSection.includes('featuredProduct') || e.target.dataset.shopifyEditorSection.includes('productInfo')) {
                let prodSec = e.target.querySelector('.productSection')
                if(!prodSec.classList.contains('noProduct')) {
                    setUpProduct(prodSec)
                } 
            }
        })
    }


    function setUpProduct(productRoot) {

        // Carousel
        const productSectionImageWrap = productRoot.querySelectorAll('.productSectionImageWrap')
        const draggableMedia = productRoot.querySelectorAll('.draggableMedia')

        let prevBtn, nextBtn
        let imgControlWrap = productRoot.querySelector('.imageControlWrap') 

        if (imgControlWrap) {
            prevBtn = imgControlWrap.children[0]
            nextBtn = imgControlWrap.children[2]
        }
        const productMediaWrap = productRoot.querySelector('.productMediaWrap')
        const currentImgIndexSpan = productRoot.querySelector('.currentImgIndex')

        let currentIndex = 0
        let cursorPositionX = 0
        let initialPosiionX = 0
        let translateTo = 0
        let isDragged = false
        let siblingImageWrapRight 
        let siblingImageWrapLeft 
        let currentImageInView
        let biggestHeightSet = false
        let initialDir = false


        for(let i = 0; i < productSectionImageWrap.length; i++) {
            if(!productSectionImageWrap[i].classList.contains('displayNone')) {
                currentIndex = i
                updateCurrentImgIndexSpan()
                break
            }
        }


        function setMediaWrapperHeight() {
            productMediaWrap.style.height = productSectionImageWrap[currentIndex].clientHeight + 'px'

        } 

        if (imgControlWrap) {
            prevBtn.addEventListener('click', prev)
            nextBtn.addEventListener('click', next)
    
            draggableMedia.forEach(img => {
                img.addEventListener('mousedown', drag)
            })
    
            // draggableMedia.forEach(img => {
            //     img.addEventListener('touchstart', drag)
            // })
    
            draggableMedia.forEach(img => {
                img.addEventListener('mouseup', drag)
            })
    
            // draggableMedia.forEach(img => {
            //     img.addEventListener('touchend', drag)
            // })
    
            draggableMedia.forEach(img => {
                img.addEventListener('mousemove', drag)
            })
    
            // draggableMedia.forEach(img => {
            //     img.addEventListener('touchmove', drag)
            // })
    
            draggableMedia.forEach(img => {
                img.addEventListener('mouseleave', setInPlace)
            })            
        }


        function prev() {
            if(productSectionImageWrap[currentIndex - 1]) {
                if(productSectionImageWrap[currentIndex].querySelector('model-viewer')){
                    unloadModel(productSectionImageWrap[currentIndex].querySelector('model-viewer'))
                }
                productSectionImageWrap[currentIndex].classList.add('displayNone')
                productSectionImageWrap[currentIndex - 1].classList.remove('displayNone')
                currentIndex --
                updateCurrentImgIndexSpan()
                resizeModelWrap()
                setMediaWrapperHeight()

            }
        }

        function next() {
            if(productSectionImageWrap[currentIndex + 1]) {
                if(productSectionImageWrap[currentIndex].querySelector('model-viewer')){
                    unloadModel(productSectionImageWrap[currentIndex].querySelector('model-viewer'))
                }
                productSectionImageWrap[currentIndex].classList.add('displayNone')
                productSectionImageWrap[currentIndex + 1].classList.remove('displayNone')
                currentIndex ++
                updateCurrentImgIndexSpan()
                resizeModelWrap()
                setMediaWrapperHeight()
            }
        }


        function changeByIndex(index) {
            index --
            productSectionImageWrap[currentIndex].classList.add('displayNone')
            productSectionImageWrap[index].classList.remove('displayNone')
            currentIndex = index
        }

        function updateCurrentImgIndexSpan() {
            currentImgIndexSpan.innerText = currentIndex + 1
        }

        function drag(e) {
            if(!e.currentTarget.classList.contains('draggableMedia')) { return }
            if (e.type == 'mousedown' || e.type == 'touchstart') {
                currentImageInView = e.currentTarget.parentElement
                translateTo = 0

                // e.preventDefault()
                if (e.type == 'touchstart') {
                    initialPosiionX = e.touches[0].clientX
                } else {
                    initialPosiionX = e.clientX
                }

                if (currentImageInView.nextElementSibling && currentImageInView.nextElementSibling.classList.contains('productSectionImageWrap')) {
                    siblingImageWrapRight = currentImageInView.nextElementSibling
                } else {
                    siblingImageWrapRight = false
                }
                if (currentImageInView.previousElementSibling && currentImageInView.previousElementSibling.classList.contains('productSectionImageWrap')) {
                    siblingImageWrapLeft = currentImageInView.previousElementSibling
                } else {
                    siblingImageWrapLeft = false
                }
                
                isDragged = true
            } 
            
            if (e.type == 'mouseup' || e.type == 'touchend') {
                setInPlace()
            } 

            if (e.type == 'mousemove' || e.type == 'touchmove') {
                if (isDragged) {

                    let currentDir

                    if(e.type == 'touchmove') {
                        cursorPositionX = e.touches[0].clientX
                    } else {
                        cursorPositionX = e.clientX
                    }
                    translateTo = cursorPositionX - initialPosiionX
                    currentImageInView.style.transform = `translateX(${translateTo}px)`   

                    if (siblingImageWrapLeft && translateTo > 0) {
                        if(!initialDir) {initialDir = 'right'}
                        currentDir = 'right'

                        if(currentDir !=  initialDir) {biggestHeightSet = false; initialDir = 'right'}                

                        siblingImageWrapLeft.classList.remove('displayNone')
                        siblingImageWrapLeft.style.transform = `translateX(-${siblingImageWrapLeft.clientWidth - translateTo + 10}px)`            
                        compareHeight(currentImageInView, siblingImageWrapLeft)
                    }
                    
                    if (siblingImageWrapRight && translateTo < 0) {
                        if(!initialDir) {initialDir = 'left'}
                        currentDir = 'left'

                        if(currentDir !=  initialDir) {biggestHeightSet = false; initialDir = 'left'}

                        siblingImageWrapRight.classList.remove('displayNone')
                        siblingImageWrapRight.style.transform = `translateX(+${siblingImageWrapRight.clientWidth + translateTo + 10}px)`
                        compareHeight(currentImageInView, siblingImageWrapRight)        
                    }


                }

            }
        }

        function setInPlace() {
            if(!isDragged) { return }
            isDragged = false


            if (siblingImageWrapLeft) {
                if (translateTo > Math.abs(currentImageInView.clientWidth) / 2) {
                    currentImageInView.classList.add('displayNone')
                    animateTranslate0(siblingImageWrapLeft)
                    currentIndex --
                } else {
                    siblingImageWrapLeft.classList.add('displayNone')
                    siblingImageWrapLeft.style.transform = "translateX(0)"
                    animateTranslate0(currentImageInView)                
                }

            } else {
                animateTranslate0(currentImageInView)
            }

            if(siblingImageWrapRight) {
                if (translateTo < -Math.abs(currentImageInView.clientWidth) / 2) {
                    currentImageInView.classList.add('displayNone')
                    animateTranslate0(siblingImageWrapRight)
                    currentIndex ++
                } else {
                    siblingImageWrapRight.classList.add('displayNone')
                    siblingImageWrapRight.style.transform = "translateX(0)"
                    animateTranslate0(currentImageInView)
                }

            } else {
                animateTranslate0(currentImageInView)
            }        

            biggestHeightSet = false
            initialDir = false
            updateCurrentImgIndexSpan()
            setMediaWrapperHeight()
        }


        function animateTranslate0(el) {
            const options = {
                duration: 200,
                fill: 'none'       
            }    

            let slide = [
                { transform: 'translateX(0px)' }
            ]
            
            let anim = el.animate(slide, options)

            anim.addEventListener('finish', () => {
                el.style.transform = 'translateX(0px)'
            })        
        }


        function compareHeight(img1, img2) {
            if(biggestHeightSet) { return }
            [...arguments].forEach(el => {
                if(el.classList.contains('modelWrap')) {
                    el.style.height = el.clientWidth + "px"
                }
            })
            let biggestHeight
            if(img1.clientHeight > img2.clientHeight) {
                biggestHeight = img1.clientHeight 
            } else {
                biggestHeight = img2.clientHeight
            }
            productMediaWrap.style.height = biggestHeight + 'px'
            biggestHeightSet = true
        }


        // Model-view
        const loadModelBtn = productRoot.querySelectorAll('.loadModelBtn')
        const zoomModelBtn = productRoot.querySelectorAll('.zoomModelBtn')

        if(loadModelBtn) {
            loadModelBtn.forEach(btn => {
                btn.addEventListener('click', laodModel)
            })
    
        }


        if(zoomModelBtn) {
            zoomModelBtn.forEach(btn => {
                btn.addEventListener('click', zoomModel)
            })    
        }

        function resizeModelWrap () {
            if(productSectionImageWrap[currentIndex].classList.contains('modelWrap')) {
                productSectionImageWrap[currentIndex].style.height = productSectionImageWrap[currentIndex].clientWidth + 'px'
            }
        }

        function zoomModel(e) {
            let action = e.currentTarget.dataset.zoomDir
            let zoom = action == 'in' ? '2.0' : '-2.0'
            e.currentTarget.parentElement.parentElement.querySelector('model-viewer').zoom(zoom)
        } 

        function laodModel(e) {
            let parentElement = e.currentTarget.parentElement 
            let model = parentElement.querySelector('model-viewer') 
            parentElement.querySelector('.modelControlsBar').classList.remove('displayNone')
            model.dismissPoster()
            model.classList.remove('draggableMedia')
            e.currentTarget.classList.add('displayNone')
        }

        function unloadModel(e) {
            let parentElement = e.parentElement 
            e.showPoster()
            e.classList.add('draggableMedia')
            parentElement.querySelector('.modelControlsBar').classList.add('displayNone')
            parentElement.querySelector('.loadModelBtn').classList.remove('displayNone')
        }

        // Set initial model height (if aplicable) and media wrapper height and attach resize event listener
        if (imgControlWrap) {
            resizeModelWrap()
            setMediaWrapperHeight()
    
            window.addEventListener('resize', () => {
                resizeModelWrap()    
                setMediaWrapperHeight()
            })
        
            let initialImageWait = productSectionImageWrap[currentIndex].querySelector('img') || 
            productSectionImageWrap[currentIndex].querySelector('model-viewer') || 
            productSectionImageWrap[currentIndex].querySelector('iframe')
            if(initialImageWait.nodeName == "IMAGE" || initialImageWait.nodeName == "iframe") {
                initialImageWait.addEventListener('load', () => {
                    resizeModelWrap()
                    setMediaWrapperHeight()
                }, {once: "true"})
            } else if (initialImageWait.nodeName == "MODEL-VIEWER" || initialImageWait.nodeName == "IFRAME") {
                setTimeout(() => {
                    resizeModelWrap()
                    setMediaWrapperHeight()
                }, 1000);
            } 
        }
    

        // Handling Adding to cart and variants update
        const cartIcon = document.querySelector('.cartIcon')
        const addToCartBtnWrap = productRoot.querySelector('.buyButtonsWrap')
        const optionBtns = productRoot.querySelectorAll('.optionBtns')
        const productHandle = productRoot.querySelector('.productHandleData').dataset.productHandle 
        const onlyDefaultvariant = productRoot.querySelector('.onlyDefaultVariant').dataset.onlyDefaultVariant
        const quantityInput = productRoot.querySelector('.quantityInput')
        const quantityPlus = productRoot.querySelector('.quantityPlus')
        const quantityMinus = productRoot.querySelector('.quantityMinus')
        const allIconsWraps = productRoot.querySelectorAll('.productAccentBoxWrap')


        const cartModal = document.querySelector('#cartModal')

        const productInfoWrap = productRoot.querySelector('.productInfoWrap')

        let productObject = false
        let reqInProg = false;

        let currentOptions = {
            option1 : null,
            option2 : null,
            option3 : null
        }

        let currentVariant = false 

        if(addToCartBtnWrap) {
            addToCartBtnWrap.addEventListener('click', addToCart)
            optionBtns.forEach(btn => {
                btn.addEventListener('click', changeVariant)
            })
        }

        if(quantityInput) {
            quantityMinus.addEventListener('click', (e) => { 
                if(quantityInput.value > 1){
                    quantityInput.value --
                }
            })
            quantityPlus.addEventListener('click', (e) => {
                quantityInput.value ++
            })
        }


        async function getProductObject() {
            const res = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`, {method: 'GET'})
            productObject = await res.json();
            populateInitalOptionValues()
        }
        getProductObject()

        
        function changeVariant(e) {
            if(reqInProg) { return }
            reqInProg = true
            quantityInput.value = 1
            let btn = e.currentTarget 
            let btnParent = btn.parentElement
            let optionVal = btn.dataset.optionValue
            let optionPos = btnParent.dataset.optionPosition

            let optionLabelSelectedOption = btn.closest('.productSectionContainer').querySelector('.optionLabelSelectedOption');
            if(optionLabelSelectedOption) {
                let labelVal = optionVal
                if(labelVal.includes('-')) {
                    labelVal = optionVal.split('-')[0]
                }

                optionLabelSelectedOption.innerText = labelVal
            }             

            showProductLoading(btn)

            let activeBtn = btnParent.querySelector('.colorBtnActive') || btnParent.querySelector('.btnActive')
            activeBtn.classList.remove('colorBtnActive')
            activeBtn.classList.remove('btnActive')

            if(btn.classList.contains('colorBtn')) {
                btn.classList.add('colorBtnActive')
            } else { 
                btn.classList.add('btnActive')
            }

            currentOptions[`option${optionPos}`] = optionVal
            findVariant()

        }


        function findVariant(initial = false) {
            if(productObject) {

                if(onlyDefaultvariant == "true") {
                    currentVariant = productObject.variants[0]
                    return
                }

                let variantFound = false
                for (let i = 0; i < productObject.variants.length; i++) {
                    if (productObject.variants[i].option1 == currentOptions.option1 && productObject.variants[i].option2 == currentOptions.option2 && productObject.variants[i].option3 == currentOptions.option3) {
                        currentVariant = productObject.variants[i]
                        if(!initial) {
                            if(window.location.pathname.includes('product')) {
                                history.replaceState({}, '', `${window.Shopify.routes.root}products/${productHandle}?variant=${currentVariant.id}`)
                            }
                            updateVariant()
                        } 
                        variantFound = true
                        break
                    }
                }

                if (!variantFound) {
                    handleNullVariant()
                }
            }
            reqInProg = false
        }


        function handleNullVariant() {
            productInfoWrap.querySelector('.priceContainer').innerHTML = ""
            let pickUpWrap = productInfoWrap.querySelector('.pickupAvailabilityWrap')
            if (pickUpWrap) {
                pickUpWrap.innerHTML = "" 
            }
            let buyBtn = productInfoWrap.querySelector('.addToCartBtn')
            buyBtn.classList.add('addToCartUnavailable')
            buyBtn.setAttribute('disabled', '')
            buyBtn.children[0].classList.add('displayNone')
            buyBtn.children[1].classList.add('displayNone')
            buyBtn.children[2].classList.remove('displayNone')
            hideProductLoading()
        }


        let sectionId = productRoot.querySelector('.sectionId').dataset.sectionId

        async function updateVariant() {
            const req = await fetch(`${window.Shopify.routes.root}products/${productHandle}?variant=${currentVariant.id}&section_id=${sectionId}`)
            const res = await req.text()        
            const dom = new DOMParser().parseFromString(res, 'text/html')
            
            const buyButtons = dom.querySelector('.buyButtonsToUpdate')
            const pickupAvailabilityWrap = dom.querySelector('.pickupAvailabilityWrap')
            const productFormVariantId = dom.querySelector('.productFormVariantId').value
            const stockWrap = dom.querySelector('.stockWrap')

            const originalPriceContainer = productInfoWrap.querySelectorAll('.productInfoBlockWrap')
            const originalBuyButtons = productInfoWrap.querySelector('.buyButtonsToUpdate') 
            const originalPickupAvailabilityWrap = productInfoWrap.querySelector('.pickupAvailabilityWrap')
            const originalStockWrap = productInfoWrap.querySelector('.stockWrap')


            if(originalStockWrap) {
                originalStockWrap.replaceWith(stockWrap)
            }

            productInfoWrap.querySelectorAll('.productFormVariantId').forEach(vId => {
                vId.value = productFormVariantId
            })

            if(originalPriceContainer) {
                originalPriceContainer.forEach(price => {
                    price.replaceWith(dom.querySelector('.productInfoBlockWrap'))
                })    
            }


            if(originalBuyButtons) {
                let btn = originalBuyButtons.querySelector('button')
                if(buyButtons.querySelector('button').classList.contains('addToCartUnavailable')) {
                    btn.classList.add('addToCartUnavailable')
                    btn.setAttribute('disabled', 'disabled')
                    btn.children[0].classList.add('displayNone')
                    btn.children[1].classList.remove('displayNone')
                    btn.children[2].classList.add('displayNone')
                } else {
                    btn.classList.remove('addToCartUnavailable')
                    btn.removeAttribute('disabled')
                    btn.children[1].classList.add('displayNone')
                    btn.children[0].classList.remove('displayNone')
                    btn.children[2].classList.add('displayNone')
                }
            }

            if(originalPickupAvailabilityWrap) {
                originalPickupAvailabilityWrap.innerHTML = "" 
                if (pickupAvailabilityWrap.children) {
                    originalPickupAvailabilityWrap.append(...pickupAvailabilityWrap.children)
                }
            }


            setPickupAvailability()
            updateImage()
            hideProductLoading()
        }

        function updateImage() {
            let currentVariantImageId = false
            if(currentVariant.featured_media) {
                currentVariantImageId = currentVariant.featured_media.id
            }
            if(currentVariantImageId) {
                let varImg = document.querySelector(`[data-image-id='${currentVariantImageId}']`)
                if(varImg) {
                    let varImgIndex = varImg.dataset.imagePosition 
                    changeByIndex(parseInt(varImgIndex, 10))
                }
            }

            setMediaWrapperHeight()
            updateCurrentImgIndexSpan()
        }

        function addToCartLoading(showLoading) {
            allIconsWraps.forEach(wrap => {
                if(showLoading) {
                    wrap.children[0].classList.add('displayNone');
                    wrap.children[1].classList.remove('displayNone');
                    wrap.children[1].classList.remove('visibilityHide');
                } else {
                    wrap.children[1].classList.add('displayNone');
                    wrap.children[0].classList.remove('displayNone');
                }
            })
        }

        async function addToCart(e) {
            e.preventDefault()
            if(reqInProg) { return }
            
            addToCartLoading(true)

            reqInProg = true
            if(!currentVariant) { return }
            if(e.target.classList.contains('addToCartBtn') && !e.target.classList.contains('addToCartUnavailable')) {
                let items = [
                    {
                        id: currentVariant.id,
                        quantity: quantityInput.value
                    }
                ]

                const parent = e.target.closest('.productInfoProductForm')
                const giftCartInfo = parent.querySelector('.giftCardInfo') 
                const props = {}     
                let giftCardFormWrap = null

                if(giftCartInfo) {
                    giftCardFormWrap = giftCartInfo.querySelector('.giftCardFormWrap') 
                    if(!giftCardFormWrap.classList.contains('displayNone')) {
                        const email = giftCardFormWrap.querySelector('input[name="properties[Recipient email]"]').value.trim()
                        const name = giftCardFormWrap.querySelector('input[name="properties[Recipient name]"]').value.trim()
                        const message = giftCardFormWrap.querySelector('textarea[name="properties[Message]"]').value.trim()
                        const sendOn = giftCardFormWrap.querySelector('input[name="properties[Send on]"]').value.trim()
                          
                        
                        props["__shopify_send_gift_card_to_recipient"] = "on"
                        props["Recipient email"] = email

                        if(name) {
                            props["Recipient name"] = name
                        }

                        if(sendOn) {
                            props["Send on"] = sendOn
                        }

                        if(message) {
                            props["Message"] = message
                        }

                        items[0]['properties'] = props

                        console.log(items)

                    }
                }

                let params = new URLSearchParams(document.location.search)
                
                if(params.get('selling_plan')) {
                    items[0].selling_plan = params.get('selling_plan')
                }

                let sections = "cart"
                let data = {items: [...items], sections}
                let res = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) })
        
                if(res.ok) {
                    let cartRes = await res.json()
                    let dom = new DOMParser().parseFromString(cartRes.sections.cart, 'text/html')
            
                    cartModal.children[0].remove()
                    cartModal.append(dom.querySelector('.modalContentWrap'))
            
                    cartIcon.classList.add('cartHasElements')
                    cartIcon.animate([{transform: 'scale(1.5)'}], {duration: 120})

                    if(giftCardFormWrap) {
                        const inputs = giftCardFormWrap.querySelectorAll('input, textarea')
                        if(inputs) {
                            inputs.forEach(inp => {
                                inp.value = ""
                            })
                        }
                    }

                } else {
                    let errors = await res.json();
                    window._popUpNotif(errors.message)
                }
            }
            reqInProg = false
            addToCartLoading(false)
        }


        
        function populateInitalOptionValues() {
            if(onlyDefaultvariant == "false") {
                const variantPickerButtonsWrap = productRoot.querySelectorAll('.variantPickerButtonsWrap')
                variantPickerButtonsWrap.forEach((wrap, index) => {
                    if(wrap.querySelector('.colorBtnActive')){
                        currentOptions[`option${index + 1}`] = wrap.querySelector('.colorBtnActive').dataset.optionValue
                    } else {
                        currentOptions[`option${index + 1}`] = wrap.querySelector('.btnActive').dataset.optionValue
                    }
                })
            }

            findVariant(true)
        };


        // Pickup Availability
        function setPickupAvailability() {
            if(productRoot.querySelector('.locationsWrapExtend')) {
                let locationsWrapExtend = productRoot.querySelector('.locationsWrapExtend')        
                let showBtn = productRoot.querySelector('.showAvailability') 
                let hideBtn = productRoot.querySelector('.hideAvailability') 

                if (locationsWrapExtend.clientHeight > 300) {
                    locationsWrapExtend.classList.add('locationsWrapExtendHide')
                    locationsWrapExtend.nextElementSibling.classList.remove('displayNone')

                    showBtn.addEventListener('click', () => {
                        locationsWrapExtend.classList.remove('locationsWrapExtendHide')
                        showBtn.classList.add('displayNone')
                        hideBtn.classList.remove('displayNone')
                    })

                    hideBtn.addEventListener('click', () => {
                        locationsWrapExtend.classList.add('locationsWrapExtendHide')
                        showBtn.classList.remove('displayNone')
                        hideBtn.classList.add('displayNone')
                    })
                }
            }        
        }

        setPickupAvailability()

        function showProductLoading(el) {
            let iconWrap = el.closest('.productSectionContainer').querySelector('.productAccentBoxWrap')
            iconWrap.children[0].classList.add('displayNone')
            iconWrap.children[1].classList.remove('displayNone')
            iconWrap.children[1].classList.remove('visibilityHide')
        }

        function hideProductLoading() {
            productRoot.querySelectorAll('.productAccentBoxWrap').forEach(wrap => {
                wrap.children[0].classList.remove('displayNone')
                wrap.children[1].classList.add('displayNone')
            })
        }

        // Portal
        const portalBtn = document.querySelectorAll('.portalBtn')
        const portal = document.querySelector('#portal')
        const portalContent = document.querySelector('#portalContent')
        const closePortal = document.querySelector('.closePortal')

        portalBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
                portalContent.innerHTML = ''

                let elementToPortal = e.currentTarget.parentElement.querySelector('.portalElement') || e.currentTarget.parentElement.parentElement.querySelector('.portalElement') 
                let clonedElement = elementToPortal.cloneNode(true)
                clonedElement.sizes = '100vw'
                portalContent.append(clonedElement)

                document.documentElement.style.overflow = 'hidden'
                portal.classList.remove('displayNone')

                portal.querySelector('.floatyBtn').focus()

                if(clonedElement.classList.contains('model')) {
                    clonedElement.dismissPoster()
                    clonedElement.classList.add('modelFullScreen')
                    let controls = elementToPortal.nextElementSibling.cloneNode(true)
                    portalContent.append(controls)
                    let zoomBtns = document.querySelector('#portalContent').querySelectorAll('.zoomModelBtn')
                    if(zoomBtns) {
                        zoomBtns.forEach(btn => {
                            btn.addEventListener('click', zoomModel)
                        })    
                    }
                    controls.children[2].classList.add('displayNone')
                    controls.children[3].classList.remove('displayNone')
                    attachClosePortal(controls.children[3])
                }
            })
        })


        attachClosePortal(closePortal)

        function attachClosePortal(el) {
            el.addEventListener('click', () => {
                portal.classList.add('displayNone')
                document.documentElement.style.overflow = 'auto'
                let zoomBtns = document.querySelector('#portalContent').querySelectorAll('.zoomModelBtn')
                if(zoomBtns) {
                    zoomBtns.forEach(btn => {
                        btn.removeEventListener('click', zoomModel)
                    })    
                    document.querySelector('#portalContent').querySelector('.exitModelBtn').removeEventListener('click', closePortal)
                }
                portalContent.innerHTML = ''
            })
        }


        window.addEventListener('keyup', (e) => {
            if(e.key == 'Escape' && !portal.classList.contains('displayNone')) {
                portal.classList.add('displayNone')
                document.documentElement.style.overflow = 'auto'
            }
        })

    }

    class CheckboxWithContent extends HTMLElement {
        constructor() {
            super()
    
            this.button = this.querySelector('button')
            this.content = this.querySelector('.content')
            this.svgWrap = this.querySelector('.customCheckboxSvg')
            this.label = this.querySelector('.toggleLabel')
            this.button.addEventListener('click', this.toggle.bind(this))
            this.label.addEventListener('click', this.toggle.bind(this))
            this.realCheckbox = this.querySelector('.realCheckbox')
            this.realCheckbox.disabled = false
            this.controlInp = this.querySelector('.controlInp')
            this.controlInp.disabled = true 

        }
    
        toggle() {            
            this.svgWrap.classList.toggle('displayNone')
            this.content.classList.toggle('displayNone')

            if(this.content.classList.contains('displayNone')) {
                this.realCheckbox.setAttribute('checked', '')
            } else {
                this.realCheckbox.removeAttribute('checked')
            }
    
        }
    }
    customElements.define('checkbox-with-content', CheckboxWithContent)

});

